import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { ButtonSettingsTypeEnum } from "../../../../../Common/Enums/ButtonSettingsTypeEnum";

export const Panel = styled.div<{ fixed?: boolean; isCustomButtons?: boolean }>(props => ({
    backgroundColor: props.isCustomButtons
        ? theme(props).keyPalette.panel3BackgroundColor
        : theme(props).keyPalette.panel2BackgroundColor,
    padding: "0 30px",
    height: props.isCustomButtons ? theme(props).size(11) : 100,
    boxShadow: props.fixed ? `0 -3px 5px 0 ${props.theme.candy.legacy.shadowColor}` : undefined,
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
}));

export const ActionButtonsContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
}));

export const FooterAdditionalText = styled.div(() => ({
    margin: "8px 0",
}));

export const SimpleFormRoot = styled.div<{ width?: number | string }>(props => ({
    margin: "0 auto",
    border: theme(props).border.solid,
    width: props.width,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    boxSizing: "border-box",
}));

export const Gap = styled.span({
    marginRight: 16,
});

export const List = styled.ul({
    padding: 0,
    margin: 0,
    listStyle: "none",
    display: "flex",
    justifyContent: "flex-end",
});

export const PopupList = styled.ul({
    width: 140,
    padding: 15,
    margin: 0,
    listStyle: "none",
    display: "block",
});

export const PopupItem = styled.li(props => ({
    padding: "7px 15px",
    margin: "0 -15px",
    cursor: "pointer",

    ":hover": {
        backgroundColor: props.theme.candy.lists.items.accentLow.backgroundColor,
    },
}));

export const PopupAction = styled.a(props => ({
    color: theme(props).typography.primary.color,
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
}));

export const SimpleFormContainer = styled.div<{ minWidth?: number | string }>(
    props => ({
        width: "100%",
        height: "100%",
        backgroundColor: props.theme.candy.keyPalette.primaryBackgroundColor,
        overflow: "hidden",
    }),
    props => ({ minWidth: props.minWidth })
);

export const SimpleFormContent = styled.div<{ padding?: number | string; customButtons?: ButtonSettingsTypeEnum }>(
    props => ({
        backgroundColor: props.theme.candy.keyPalette.primaryBackgroundColor,
        padding: props.customButtons === ButtonSettingsTypeEnum.DigitalWarrant ? "20px 32px" : (props.padding ?? 30),
    })
);
